export default "__VITE_ASSET__BmeK9g7G__"